import React, { useState, useEffect } from "react";
import styles from "./style.module.css";
import axios from "axios";
import tetherLand from "../../../Assets/exchanges/thetherLand.png";
import exir from "../../../Assets/exchanges/exir.png";
import bitPin from "../../../Assets/exchanges/bitpin.png";
import wallex from "../../../Assets/exchanges/wallex.png";
import sorixPay from "../../../Assets/Logo1.png";

const Main = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [landPrice, setLandPrice] = useState(null);
  useEffect(() => {
    axios.get("https://market.tetherland.com/last_trades").then((res) => {
      const usdtPrice = res.data.data[0].price;
      setLandPrice(usdtPrice);
      setIsLoading(false);
    });
  }, []);
  const [pinPrice, setPinPrice] = useState(null);
  useEffect(() => {
    axios
      .get("https://api.bitpin.ir/api/v1/mth/matches/USDT_IRT/")
      .then((res) => {
        const latestTrade = res.data[0];
        setPinPrice(latestTrade.price);
      });
  }, []);
  const [exPrice, setExPrice] = useState(null);
  useEffect(() => {
    axios
      .get("https://api.exir.io/v2/minicharts?assets=usdt,usdt&quote=irt")
      .then((res) => {
        const latestPrice = res.data.usdt[0];
        setExPrice(latestPrice.price);
      });
  }, []);
  const [wallPrice, setWallPrice] = useState(null);
  useEffect(() => {
    axios.get("https://api.wallex.ir/v1/trades?symbol=USDTTMN").then((res) => {
      const latestTrade = res.data.result.latestTrades[0].price;
      const newPrice = Math.round(latestTrade);
      setWallPrice(newPrice);
    });
  }, []);
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    setInterval(() => setTime(new Date()), 1000);
  }, []);

  const option = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return (
    <>
      {isLoading ? (
        <div className={styles.loading}>
          <div className={styles.loader}></div>
        </div>
      ) : (
        <div className={styles.main_box}>
          <table className={styles.table}>
            <thead className={styles.table_head}>
              <tr className={styles.table_descs}>
                <th className={styles.table_desc}>کارمزد</th>
                <th className={styles.table_desc}>قیمت فروش</th>
                <th className={styles.table_desc}>قیمت خرید</th>
                <th className={styles.table_desc}>نام صرافی</th>
              </tr>
            </thead>
            <tbody className={styles.table_body}>
              <tr className={styles.table_body_descs}>
                <th className={styles.table_body_desc}>%۰</th>
                <th className={styles.table_body_desc}>
                  <div className={styles.toman}>تومان </div> {exPrice - 50}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.toman}>تومان </div> {exPrice - 100}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.table_start}>
                    سوریکس پی
                    <div className={styles.exchanges1}>
                      <img className={styles.img_res} src={sorixPay} alt="" />
                    </div>
                  </div>
                </th>
              </tr>
              <tr className={styles.table_body_descs}>
                <th className={styles.table_body_desc}>٪۰.۰۸ - ٪۰.۲</th>
                <th className={styles.table_body_desc}>
                  <div className={styles.toman}>تومان </div>
                  {landPrice}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.toman}>تومان </div>
                  {landPrice}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.table_start}>
                    تتر لند
                    <div className={styles.exchanges2}>
                      <img className={styles.img_res} src={tetherLand} alt="" />
                    </div>
                  </div>
                </th>
              </tr>
              <tr className={styles.table_body_descs}>
                <th className={styles.table_body_desc}>٪۰.۱۸ - ٪۰.۳۹</th>
                <th className={styles.table_body_desc}>
                  {" "}
                  <div className={styles.toman}>تومان </div>
                  {exPrice}
                </th>
                <th className={styles.table_body_desc}>
                  {" "}
                  <div className={styles.toman}>تومان </div>
                  {exPrice}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.table_start}>
                    اکسیر
                    <div className={styles.exchanges3}>
                      <img className={styles.img_res} src={exir} alt="" />
                    </div>
                  </div>
                </th>
              </tr>
              <tr className={styles.table_body_descs}>
                <th className={styles.table_body_desc}>٪۰.۰۶ - ٪۰.۳۲</th>
                <th className={styles.table_body_desc}>
                  <div className={styles.toman}>تومان </div>
                  {pinPrice}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.toman}>تومان </div>
                  {pinPrice}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.table_start}>
                    بیت پین
                    <div className={styles.exchanges4}>
                      <img className={styles.img_res} src={bitPin} alt="" />
                    </div>
                  </div>
                </th>
              </tr>
              <tr className={styles.table_body_descs}>
                <th className={styles.table_body_desc}>٪۰.۱۳ - ٪۰.۲</th>
                <th className={styles.table_body_desc}>
                  {" "}
                  <div className={styles.toman}>تومان </div>
                  {wallPrice}
                </th>
                <th className={styles.table_body_desc}>
                  {" "}
                  <div className={styles.toman}>تومان </div>
                  {wallPrice}
                </th>
                <th className={styles.table_body_desc}>
                  <div className={styles.table_start}>
                    والکس
                    <div className={styles.exchanges5}>
                      <img className={styles.img_res} src={wallex} alt="" />
                    </div>
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
          <div className={styles.date_boxes}>
            <time className={styles.date_en} datetime="">
              {time.toDateString(option)}
            </time>
            <time className={styles.date_fa} datetime="">
              {time.toLocaleDateString("fa-IR", option)}
            </time>
          </div>
        </div>
      )}
    </>
  );
};

export default Main;
